import React from 'react';
import { Col, Form, FormGroup, Label, Row } from 'reactstrap';
import SuperInput from '@/components/sharedComponents/SuperInput';

interface StateProps {
  fileName?: string;
}

interface DispatchProps {
  onChangeFileInput: (file: File | undefined) => void;
}

type Props = StateProps & DispatchProps;

export const LoadCsvContent: React.FC<Props> = ({ fileName, onChangeFileInput }): JSX.Element => {
  const callGetFileButton = (): void => {
    document.getElementById('fileCSV')?.click();
  };
  return (
    <Form
      noValidate={true}
      onSubmit={(e): void => {
        e.preventDefault();
      }}
    >
      <Row>
        <Col md={8}>
          <FormGroup className="mb-2">
            <div className="">
              <Label
                className="fieldLabel"
                for="printLayoutBase64"
                style={{ paddingBottom: '0px !important;' }}
              >
                Arquivo CSV
              </Label>

              <label
                style={{
                  // width: '546px',
                  height: '62px',
                  borderRadius: '5px',
                  backgroundColor: '#E6E6E6',
                  border: 'none',
                  width: '100%',
                }}
              >
                <button
                  onClick={() => callGetFileButton()}
                  style={{
                    marginLeft: '10px',
                    marginTop: '6px',
                    marginRight: '4px',
                    border: '0.1em solid',
                    borderRadius: '3px',
                  }}
                >
                  Escolher arquivo
                </button>
                {fileName || 'Nenhum arquivo escolhido'}
              </label>

              <SuperInput
                id="fileCSV"
                placeholder={fileName || 'Nenhum arquivo escolhido'}
                title={fileName || 'Nenhum arquivo escolhido'}
                name="imageBase64"
                type="file"
                style={{ display: 'none' }}
                onChange={e => onChangeFileInput((e.target as HTMLInputElement)?.files?.[0])}
              />
            </div>
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
};
